import { uuidv4 } from '../../utils/uuid';
import { actions, selectors, actionIntents } from '../ducks/clipboard';
import { actions as sessionActions } from '../ducks/session';
import { actionCreators as edgesActionCreators } from '../ducks/resource-edges';





export const clipboardMiddleware = ({ getState, dispatch }) => {

  // message channel communicates between tabs of the same origin
  const bc = new BroadcastChannel("CHANNEL:CUBE3/CLIPBOARD");

  // unique id, so we can ignore ourselves
  const sender = uuidv4()

  // use in pull based flow, so only one response is consumed
  let idempotency_token;


  bc.addEventListener('message', ev => {

    // probably redundant
    if (ev.origin === window.location.origin) {
      const s = getState().session;
      const m = ev.data.action.meta

      // for now we want to only allow copy pasting in the same workspace 
      // although technically it would already be possible to allow cross workspace copying
      if (
        s?.workspace === m.workspace
        && s?.user === m.user
        && m.sender !== sender
      ) {

        // dispatch the copy action from the sender locally, to update our state
        if ([actions.COPY_ITEMS, actions.MOVE_ITEMS].includes(ev.data?.action.type)) {

          // for actions received after a sync request, we only want to dispatch
          // once, even though multiple tabs might respond to our request
          if (m.idempotency_token && m.idempotency_token !== idempotency_token) {
            return
          }

          idempotency_token = undefined
          dispatch(ev.data.action)

        }
        // when receiving a sync request
        else if (ev.data?.action.type === actions.REQUEST_CLIPBOARD_SYNC) {
          const c = getState().clipboard;

          // ignore when clipboard is empty 
          if (!c?.actionIntent) {
            return
          }
          // dispatch a "synthetic" copy event, based on the current state
          bc.postMessage({
            action: {
              type: c.actionIntent === actionIntents.COPY_INTENT ? actions.COPY_ITEMS : actions.MOVE_ITEMS,
              payload: { items: c.items, fromFolder: c.fromFolder },
              meta: { workspace: getState().session.workspace, user: getState().session.user, sender: sender, idempotency_token: ev.data.action.meta.idempotency_token }
            }
          })
        }
      }
    }
  })

  // initial sync request
  idempotency_token = uuidv4()
  bc.postMessage({
    action: {
      type: actions.REQUEST_CLIPBOARD_SYNC,
      meta: { workspace: getState().session.workspace, user: getState().session.user, sender: sender, idempotency_token }
    }
  });


  return next => action => {
    // Call the next dispatch method in the middleware chain.
    switch (action.type) {

      // request sync when workspace changes
      case sessionActions.SET_CURRENT_ACCOUNT:
        idempotency_token = uuidv4()
        bc.postMessage({
          action: {
            type: actions.REQUEST_CLIPBOARD_SYNC,
            meta: { workspace: action.meta.apiClient.workspaceId, user: getState().session.user, sender: sender, idempotency_token }
          }
        });
        return next(action)

      case actions.COPY_ITEMS:
      case actions.MOVE_ITEMS:
        // propagate a copy action to all listeners
        if (!action.meta?.sender) {
          bc.postMessage({
            action: {
              ...action,
              meta: { ...action.meta, workspace: getState().session.workspace, user: getState().session.user, sender: sender }
            }
          });
        }
        return next(action);


      case actions.PASTE_ITEMS: {
        const items = selectors.getClipboardItems(getState().clipboard);
        const intent = selectors.getClipboardIntent(getState().clipboard);
        const fromFolder = selectors.getClipboardFromFolder(getState().clipboard);

        // TODO: find a more general / less ugly way to handle this
        switch (intent) {
          case actionIntents.MOVE_INTENT:
            dispatch(edgesActionCreators.uglyMoveItems(items, action.payload, fromFolder));
            break;
          case actionIntents.COPY_INTENT:
            dispatch(edgesActionCreators.uglyCopyItems(items, action.payload));
            break;
          default:
            break;
        }
        return next(action);
      }
      default:
        return next(action);
    }
  };
};

export default clipboardMiddleware;